export default {
    LOAD_CONTENTS(state, content) {
        state.items = content
    }
}